/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Live_Title_ShortInputs */

const en_features_live_title_short = /** @type {(inputs: Features_Live_Title_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coached training`)
};

const pl_features_live_title_short = /** @type {(inputs: Features_Live_Title_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening z trenerem`)
};

/**
* | output |
* | --- |
* | "Coached training" |
*
* @param {Features_Live_Title_ShortInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_live_title_short = /** @type {((inputs?: Features_Live_Title_ShortInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Live_Title_ShortInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_live_title_short(inputs)
	return en_features_live_title_short(inputs)
});